import React, { useEffect, useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import RichTextEditor from "../../Component/RichTextEditor";
import {
  fetchPrivacyPolicy,
  updatePrivacyPolicy,
} from "../../Services/privacy_policy";
import { Spin } from "antd";

const PrivacyAndPolicy = () => {
  const [editorContent, setEditorContent] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["privacyPolicy"],
    queryFn: fetchPrivacyPolicy,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const mutation = useMutation({
    mutationFn: updatePrivacyPolicy,
    onSuccess: (updatedData) => {
      setEditorContent(updatedData?.value || "");
      console.log("Privacy Policy Updated Successfully");
    },
  });

  const handleEditorSubmit = (content) => {
    mutation.mutate({ value: content }); // Ensure `value` matches API's expected payload
  };

  useEffect(() => {
    if (data?.length) {
      setEditorContent(data[0]?.value);
    }
  }, [data]);

  return (
    <div>
      <h3>Privacy Policy</h3>
      <Spin spinning={isLoading}>
        <RichTextEditor
          initialValue={editorContent}
          onSubmit={handleEditorSubmit}
          loading={mutation?.isPending}
        />
      </Spin>
    </div>
  );
};

export default PrivacyAndPolicy;
